import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addConversation } from '../../features/appSlice';

const ConversationGoal = (props) => {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const conversationGoalRef = useRef();
    const saveConversation = () => {
        dispatch(addConversation(conversationGoalRef.current.value.replace(/<br\/>/g, '\n')));
    }

    return (
        <div className={`tab-pane fade ${(props.activeTab === 5) && 'show active'}`} id="conversationgoal" role="tabpanel" aria-labelledby="conversationgoal-tab">
            <div className='col-md-12'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="box-title">This is overview and overall goal of the conversation flow:</div>
                    </div>
                    <div className="col-md-12">

                        <textarea
                            rows={10}
                            className={`form-control`}
                            onChange={saveConversation}
                            value={state.app.contextData.conversation_goal.replace(/<br\/>/g, '\n')}
                            ref={conversationGoalRef}
                            style={{ whiteSpace: 'pre-wrap' }}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ConversationGoal